import OfflinePinOutlinedIcon from '@mui/icons-material/OfflinePinOutlined';
import * as React from 'react';
import { Link as RouterLink } from "react-router-dom";
import { AppRoutes } from '../../constants/routes';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import MenuIcon from '@mui/icons-material/Menu';
import IconButton from '@mui/material/IconButton';
import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import LibraryMusicOutlinedIcon from '@mui/icons-material/LibraryMusicOutlined';
import FavoriteBorderOutlinedIcon from '@mui/icons-material/FavoriteBorderOutlined';
import HistoryToggleOffOutlinedIcon from '@mui/icons-material/HistoryToggleOffOutlined';
import ExploreOutlinedIcon from '@mui/icons-material/ExploreOutlined';
import MapOutlinedIcon from '@mui/icons-material/MapOutlined';
import PlaylistPlayIcon from '@mui/icons-material/PlaylistPlay';
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import SearchIcon from '@mui/icons-material/Search';
import StarIcon from '@mui/icons-material/Star';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import { useAuthProvider } from '../../utils/auth';


const SideMenuMusicCon = () => {
  const [open, setOpen] = React.useState(false);
  const { isAuthed } = useAuthProvider();

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };

  const DrawerList = (
    <Box 
    sx={{
      width: 200,
      bgcolor: 'background.paper',
      color: 'text.primary',
      height: '100%', 
    }}
    role="presentation" 
    onClick={toggleDrawer(false)}>
      <List>
          <ListItem disablePadding>
            <ListItemButton
            component={RouterLink}
            to={isAuthed ? AppRoutes.Home2 : AppRoutes.Home1}
            >
              <ListItemIcon>
                <HomeRoundedIcon/>
              </ListItemIcon>
              <ListItemText primary="Home"/>
            </ListItemButton>
          </ListItem>

          <ListItem disablePadding>
            <ListItemButton
            component={RouterLink}
            to={AppRoutes.Exclusives}>
              <ListItemIcon>
                <StarIcon/>
              </ListItemIcon>
              <ListItemText primary="Exclusives"/>
            </ListItemButton>
          </ListItem>

          <ListItem disablePadding>
            <ListItemButton
            component={RouterLink}
            to={AppRoutes.Search}>
              <ListItemIcon>
                <SearchIcon/>
              </ListItemIcon>
              <ListItemText primary="Search"/>
            </ListItemButton>
          </ListItem>

          <ListItem disablePadding>
            <ListItemButton
            component={RouterLink}
            to={AppRoutes.Browsing}>
              <ListItemIcon>
                <ExploreOutlinedIcon/>
              </ListItemIcon>
              <ListItemText primary="Explore"/>
            </ListItemButton>
          </ListItem>

          <ListItem disablePadding>
            <ListItemButton
            component={RouterLink}
            to={AppRoutes.Socials}>
              <ListItemIcon>
                <ChatBubbleOutlineIcon/>
              </ListItemIcon>
              <ListItemText primary="Socials"/>
            </ListItemButton>
          </ListItem>

          <ListItem disablePadding>
            <ListItemButton
            component={RouterLink}
            to={AppRoutes.MapDiscovery}>
              <ListItemIcon>
                <MapOutlinedIcon/>
              </ListItemIcon>
              <ListItemText primary="Map Discovery"/>
            </ListItemButton>
          </ListItem>

          {/* Only show authenticated user features */}
          {isAuthed && (
            <>
              <ListItem disablePadding>
                <ListItemButton
                component={RouterLink}
                to={AppRoutes.Library}
                >
                  <ListItemIcon>
                    <LibraryMusicOutlinedIcon/>
                  </ListItemIcon>
                  <ListItemText primary="Library"/>
                </ListItemButton>
              </ListItem>

              <ListItem disablePadding>
                <ListItemButton
                component={RouterLink}
                to={AppRoutes.Downloads}
                >
                  <ListItemIcon>
                    <OfflinePinOutlinedIcon/>
                  </ListItemIcon>
                  <ListItemText primary="Purchased Music"/>
                </ListItemButton>
              </ListItem>

              <ListItem disablePadding>
                <ListItemButton
                  component={RouterLink}
                  to={AppRoutes.LikesPage}
                >
                  <ListItemIcon>
                    <FavoriteBorderOutlinedIcon/>
                  </ListItemIcon>
                  <ListItemText primary="Likes"/>
                </ListItemButton>
              </ListItem>
            </>
          )}

      </List>
      
      {/* Only show authenticated user features */}
      {isAuthed && (
        <>
          <Divider />
          <List>
            <ListItem disablePadding>
              <ListItemButton
                component={RouterLink}
                to={AppRoutes.UserPlaylists}
              >
                <ListItemIcon>
                  <PlaylistPlayIcon/>
                </ListItemIcon>
                <ListItemText primary="My Playlists"/>
              </ListItemButton>
            </ListItem>

            <ListItem disablePadding>
              <ListItemButton
                component={RouterLink}
                to={AppRoutes.PlaylistBuilder}
              >
                <ListItemIcon>
                  <PlaylistAddIcon/>
                </ListItemIcon>
                <ListItemText primary="Create Playlist"/>
              </ListItemButton>
            </ListItem>


            <ListItem disablePadding>
              <ListItemButton
                component={RouterLink}
                to={AppRoutes.History}
              >
                <ListItemIcon>
                  <HistoryToggleOffOutlinedIcon/>
                </ListItemIcon>
                <ListItemText primary="History"/>
              </ListItemButton>
            </ListItem>

          </List>
        </>
      )}
    </Box>
  );

  return (
    <div>
      <IconButton
        onClick={toggleDrawer(true)}
      >
        <MenuIcon />
      </IconButton>

        <Drawer 
          variant="temporary"
          open={open} 
          onClose={toggleDrawer(false)}
          sx={{
            '& .MuiDrawer-paper': {
              bgcolor: 'background.paper',
              color: 'text.primary', 
            },
          }}>
          {DrawerList}
        </Drawer>   
    </div>
  );
}

export default SideMenuMusicCon;
